import styled from 'styled-components';
import { HistoryHeader } from '../styles';
import { colors } from 'styles/colors';

export const MapContainerLoading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;

  .skeleton-container-span {
    margin-top: -4px;
  }

  & > div {
    display: flex;
    gap: 8px;
    align-items: center;

    & > span:nth-child(1) {
      margin-right: 8px;
    }

    & > span:nth-child(3) {
      flex: 1;
    }

    & > span:nth-child(3) > .skeleton-span {
      height: 22px;
    }
  }

  & > span {
    margin-top: -4px;
    flex: 1;

    .skeleton-span {
      height: 520px;
    }
  }

  @media (max-width: 768px) {
    flex: 1 1 100%;

    & > div {
      & > span:nth-child(3) > .skeleton-span {
        height: 66px;
      }
    }

    & > .skeleton-span {
      width: 100%;
      height: 554px;
    }
  }
`;

export const MapContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: start;
  justify-content: flex-start;
`;

export const MapContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: start;

  width: 100%;
  flex: 1;
  gap: 8px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const MapHeader = styled(HistoryHeader)`
  & > span {
   font-size: 12px;
   line-height: 180%;
   font-weight: 400;
   color: ${colors.text['soft-400']};
   word-wrap: break-word;
  }
  & > h3 {
    flex-shrink: 0;
  }

`;

export const MapInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;
